// extracted by mini-css-extract-plugin
module.exports = {"tab-pane-content-wrapper":"TabPaneHeader_tab-pane-content-wrapper__2jei4"};